import React from 'react';
import PropTypes from 'prop-types';

import defaultIcon from 'assets/AllCropSVGs/fallow.svg';
import CropIcons from 'helpers/getCropIconByCropName';
import CropIconMapping from 'components/CropIconMapping';
import toCamelCase from '../../helpers/toCamelCase';

const PropertyCropHistorySummaryCell = ({ data, field }) => {
  const scrubbedProduct = {
    ...data,
    name: data?.cropname?.replaceAll(' ', '')
  };

  const cropName = scrubbedProduct?.name?.includes(':')
    ? scrubbedProduct?.name
        .split(':')
        .map(part => toCamelCase(part.trim()))
        .join('')
    : scrubbedProduct?.name;
  // One column of the row, picked by `field`: the UI Kit table renders
  // cell by cell.
  const cells = {
    cropseason: (
      <div
        style={{
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          overflowWrap: 'break-word'
        }}
      >
        <div>{data?.cropseason}</div>
      </div>
    ),
    cropname: (
      <div className="flex gap-1 h-4">
        {cropName in CropIcons ? (
          <CropIconMapping cropObject={scrubbedProduct} />
        ) : (
          <img src={defaultIcon} alt="" />
        )}
        {data?.cropname}
      </div>
    )
  };

  return cells[field] ?? null;
};

PropertyCropHistorySummaryCell.propTypes = {
  field: PropTypes.string.isRequired,
  data: PropTypes.shape({
    cropseason: PropTypes.string.isRequired,
    cropZones: PropTypes.arrayOf(PropTypes.object).isRequired,
    cropname: PropTypes.string.isRequired,
    variety: PropTypes.string.isRequired,
    plantingDate: PropTypes.string.isRequired,
    area: PropTypes.string.isRequired
  }).isRequired
};

export default PropertyCropHistorySummaryCell;
